import { createReducer } from 'helpers/ReducerUtil'
import { combineReducers } from 'redux'

import {
  CLEAR_TEST_LIST,
  UPDATE_TEST_LIST,
  UPDATE_TEST_PROFILES,
  CLEAR_TEST_PROFILES,
  CLEAR_TEST_CONFIG_NAMES,
  UPDATE_TEST_CONFIG_NAMES
} from './constants'

const initTestProfiles = {
  greenLightProfiles: [],
  nvqualProfiles: [],
}

const initConfigNames = {
  greenLightProfileName: '',
  nvqualProfileName: '',
}

const updateTestList = (prev, { tests } ) => {
  return tests ? [...tests] : []
}
const updateTestProfiles = (prev, { testProfiles } ) => {
  return testProfiles ? {...testProfiles} : initTestProfiles
}

const updateTestConfigNames = (prev, { configNames } ) => {
  return configNames ? {...configNames} : initConfigNames
}

const testListReducer = createReducer([], {
  [CLEAR_TEST_LIST]: () => [],
  [UPDATE_TEST_LIST]: updateTestList
})

const testProfilesReducer = createReducer(initTestProfiles, {
  [CLEAR_TEST_PROFILES]: () => initTestProfiles,
  [UPDATE_TEST_PROFILES]: updateTestProfiles
})

const testConfigNamesReducer = createReducer(initConfigNames, {
  [CLEAR_TEST_CONFIG_NAMES]: () => initConfigNames,
  [UPDATE_TEST_CONFIG_NAMES]: updateTestConfigNames,
})

export default combineReducers({
  testList: testListReducer,
  testProfiles: testProfilesReducer,
  testConfigNames: testConfigNamesReducer,
})